// Live-input formatter (mirrors the payments / conceptos pattern): adds
// thousands separators as the user types while preserving partial states
// like "5." or "5.0".
export const fmtMXNInput = (v) => {
  const str = String(v ?? "").replace(/,/g, "");
  if (str === "" || str === "-" || str === "-.") return str;
  const n = Number(str);
  if (isNaN(n)) return "";
  const sign = str.startsWith("-") ? "-" : "";
  const abs = Math.abs(n);
  if (str.endsWith(".")) return sign + abs.toLocaleString("es-MX") + ".";
  const decMatch = str.match(/\.(\d{1,2})$/);
  if (decMatch) {
    return (
      sign +
      abs.toLocaleString("es-MX", {
        minimumFractionDigits: decMatch[1].length,
        maximumFractionDigits: 2,
      })
    );
  }
  return sign + abs.toLocaleString("es-MX");
};

// Strip the live-formatted value back to a normalized raw string for state.
export const normalizeMoneyInput = (raw) => {
  let s = String(raw ?? "").replace(/[^\d.-]/g, "");
  if (s.includes("-")) s = "-" + s.replace(/-/g, "");
  s = s.replace(/(\..*)\./g, "$1").replace(/(\.\d{2})\d+/, "$1");
  return s;
};
